import httpClient from '../../../../utils/httpClient';
import { ApiSuccessResponse } from '../../../../utils/apiSchemas';

export interface SendWarningEmailBlastRequest {
  subject: string;
  emails: string;
  html: string;
}

export const sendWarningEmailBlastNow = async (
  payload: SendWarningEmailBlastRequest
): Promise<ApiSuccessResponse<boolean>> => {
  const response = await httpClient.post<ApiSuccessResponse<boolean>>(
    `/api/v1/portal/warning-email-blast/send-now`,
    payload
  );
  return response.data;
};

export interface WarningEmailBlastHistoryItem {
  dispatchGuid: string;
  createdDate: string;
  subject?: string | null;
  addressDestiny?: string | null;
  bccEmails?: string | null;
  sentSuccess?: boolean | null;
}

export interface WarningEmailBlastHistoryResponse {
  items: WarningEmailBlastHistoryItem[];
  total: number;
  pageNumber: number;
  pageSize: number;
}

export const getWarningEmailBlastHistory = async (
  pageNumber: number,
  pageSize: number
): Promise<ApiSuccessResponse<WarningEmailBlastHistoryResponse>> => {
  const response = await httpClient.get<ApiSuccessResponse<WarningEmailBlastHistoryResponse>>(
    `/api/v1/portal/warning-email-blast/history`,
    {
      params: {
        pageNumber,
        pageSize
      }
    }
  );
  return response.data;
};

export interface WarningEmailBlastHtmlResponse {
  dispatchGuid: string;
  html: string;
}

export const getWarningEmailBlastHtml = async (
  dispatchGuid: string,
  signal?: AbortSignal
): Promise<ApiSuccessResponse<WarningEmailBlastHtmlResponse>> => {
  const response = await httpClient.get<ApiSuccessResponse<WarningEmailBlastHtmlResponse>>(
    `/api/v1/portal/warning-email-blast/history/${dispatchGuid}/html`,
    {
      signal
    }
  );
  return response.data;
};
